<template>
  <div>
   <MonthlyBalanceTransactionList/>
  </div>
</template>

<script>
import MonthlyBalanceTransactionList from '../../../components/tax/payments/monthlyBalance/monthlyBalanceTransactionList.vue';

export default {
  name: 'AuditMonthlyBalance',
  components: {
    MonthlyBalanceTransactionList,
  },
};
</script>
